import React from 'react';
import './Legal.css';

export default function Privacy() {
  return (
    <div className="legal-page">
      <section className="legal-hero section-dark">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>Last updated: March 1, 2025</p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="legal-content">
            <p>Sculpit Innovations Private Limited ("Sculpit", "we", "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform.</p>

            <h2>1. Information We Collect</h2>
            <h3>Personal Information</h3>
            <p>When you create an account or use our services, we may collect:</p>
            <ul>
              <li>Name, email address, phone number</li>
              <li>Property details (plot location, dimensions)</li>
              <li>Home design preferences and project requirements</li>
              <li>Payment information (processed securely through our payment partners)</li>
              <li>Communication records (chat, email, phone calls)</li>
            </ul>

            <h3>Usage Information</h3>
            <p>We automatically collect information about how you interact with our platform, including pages visited, features used, design actions taken, and time spent on the platform.</p>

            <h2>2. How We Use Your Information</h2>
            <ul>
              <li>To provide and improve our 3D design, cost estimation, and construction management services</li>
              <li>To match you with verified construction partners</li>
              <li>To process payments through our escrow system</li>
              <li>To send project updates, notifications, and relevant communications</li>
              <li>To improve our AI algorithms and platform features</li>
              <li>To comply with legal obligations</li>
            </ul>

            <h2>3. Information Sharing</h2>
            <p>We share your information only with:</p>
            <ul>
              <li><strong>Construction Partners:</strong> Project-relevant details necessary for construction execution</li>
              <li><strong>Financial Partners:</strong> Information required for loan processing and escrow management</li>
              <li><strong>Service Providers:</strong> Third-party services that help us operate our platform</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
            </ul>
            <p>We never sell your personal information to third parties.</p>

            <h2>4. Data Security</h2>
            <p>We implement industry-standard security measures including encryption, secure servers, access controls, and regular security audits. Payment information is processed by PCI-DSS compliant payment partners.</p>

            <h2>5. Data Retention</h2>
            <p>We retain your data for as long as your account is active or as needed to provide services. Project data is retained for 7 years after project completion for warranty and legal compliance purposes.</p>

            <h2>6. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Correct inaccurate information</li>
              <li>Delete your account and associated data</li>
              <li>Export your design and project data</li>
              <li>Opt out of marketing communications</li>
            </ul>

            <h2>7. Cookies</h2>
            <p>We use cookies and similar technologies to improve your experience, analyze usage patterns, and deliver relevant content. You can control cookie preferences through your browser settings.</p>

            <h2>8. Children's Privacy</h2>
            <p>Our services are not intended for individuals under 18 years of age. We do not knowingly collect personal information from children.</p>

            <h2>9. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. We will notify you of any material changes via email or platform notification.</p>

            <h2>10. Contact Us</h2>
            <p>For privacy-related inquiries:</p>
            <ul>
              <li>Email: privacy@sculpit.in</li>
              <li>Address: Sculpit Innovations Private Limited, No 17, 1st Floor, Bank of Baroda Building, 3rd Main Road, NGEF Layout, Postal Colony, Sanjayanagara, Bengaluru 560094, India</li>
              <li>CIN: U43900KA2026PTC217041</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
